import { action } from "typesafe-actions";

import { SystemParametersTypes, ParammetersTypes } from "./types";

export const getSystemParametersAction = () =>
  action(SystemParametersTypes.GET_PARAMETERS);

export const setSystemParametersAction = (data: ParammetersTypes) =>
  action(SystemParametersTypes.SET_PARAMETERS, data);
